<template>
  <div
    class="s-strip s-leasing-bonus-slick"
    :class="{
      's-leasing-bonus-slick--with-sidebar': configuration.withSidebar,
    }">
    <div class="page-container">
      <div class="s-leasing-bonus-slick__body">
        <SlickCarousel
          ref="slick"
          :key="'key-' + slickKey"
          class="s-leasing-bonus-slick__slick"
          :options="slickOptions">
          <div
            v-for="(item, index) in records"
            :key="index"
            class="s-leasing-bonus-slick__slide item">
            <div class="b-leasing-bonus-card">
              <div class="b-leasing-bonus-card__picture">
                <LazyImage v-if="item.image" :image="item.image" />
              </div>
              <div class="b-leasing-bonus-card__main">
                <div class="b-leasing-bonus-card__title mb-15">
                  {{ item.title }}
                </div>
                <div class="h3" v-html="item.summary"></div>
              </div>
            </div>
          </div>
        </SlickCarousel>
        <div ref="navDots" class="s-leasing-bonus-slick__nav-dots"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import SlickCarousel from '../components/common/SlickCarousel.vue'
import LazyImage from './../components/common/LazyImage.vue'

export default {
  components: { LazyImage, SlickCarousel },

  data() {
    return {
      records: [],
      slickKey: 0,
      slickOptions: {
        infinite: true,
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        appendDots: '.s-leasing-bonus-slick__nav-dots',
        responsive: [
          {
            breakpoint: 992,
            settings: { slidesToShow: 1, arrows: false },
          },
        ],
      },
    }
  },
  mounted() {
    const { records } = lib.getData('leasingBonusSlickData')
    this.records = records
  },
}
</script>
